import React from "react";
import { array, object, string, func } from "prop-types";

import { MenuItem } from "../helper-components";

import "./navbar.m.css";

const Navbar = ({ menu, navbarMenuStyle, toggleVerticalMenubar }) => {
  return (
    <nav styleName="navbar" className="navbar">
      {menu && menu.length > 0 ? (
        <ul styleName="navbar-list" className="navbar-list">
          {menu.map((item, index) => (
            <li
              key={index}
              styleName={`menu-item  ${item["item-type"] === "placeholder" ? "menu-item-placeholder" : ""}`}
              className="menu-item"
              style={navbarMenuStyle}
            >
              <div>
                <MenuItem item={item} itemClick={toggleVerticalMenubar} />
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </nav>
  );
};

Navbar.propTypes = {
  menu: array,
  navbarMenuStyle: object,
  toggleVerticalMenubar: func,
  dataTagCategory: string,
};

export default Navbar;
